import AppDispatcher from "./AppDispatcher";

class BetslipActions {
    setDefaults(data) {
        AppDispatcher.dispatch({
            actionType: "SET_DEFAULTS",
            value: data
        });
    }

    toggleBetslip(data) {
        AppDispatcher.dispatch({
            actionType: "TOGGLE_BETSLIP",
            value: data
        });
    }

    expandBetslip(data) {
        AppDispatcher.dispatch({
            actionType: "EXPAND_BETSLIP",
            value: data
        });
    }

    changeStake(data) {
        AppDispatcher.dispatch({
            actionType: "CHANGE_STAKE",
            value: data
        });
    }

    changeOdds(data) {
        AppDispatcher.dispatch({
            actionType: "CHANGE_ODDS",
            value: data
        });
    }

    stepOdds(data) {
        AppDispatcher.dispatch({
            actionType: "STEP_ODDS",
            value: data
        });
    }

    validateOdds(data) {
        AppDispatcher.dispatch({
            actionType: "VALIDATE_ODDS",
            value: data
        });
    }

    stepStake(data) {
        AppDispatcher.dispatch({
            actionType: "STEP_STAKE",
            value: data
        });
    }

    placeBets(data) {
        AppDispatcher.dispatch({
            actionType: "PLACE_BETS",
            value: data
        });
    }

    placedBets(data) {
        AppDispatcher.dispatch({
            actionType: "PLACED_BETS",
            value: data
        });
    }

    placedMultipleBets(data) {
        AppDispatcher.dispatch({
            actionType: "PLACED_MULTIPLE_BETS",
            value: data
        });
    }

    removeBet(data) {
        AppDispatcher.dispatch({
            actionType: "REMOVE_PRICE",
            value: data
        });
        AppDispatcher.dispatch({
            actionType: "REMOVE_BET",
            value: data
        });
    }

    resetBets(data) {
        AppDispatcher.dispatch({
            actionType: "RESET_BETS",
            value: data
        });
    }

    updateMarket(data) {
        AppDispatcher.dispatch({
            actionType: "UPDATE_MARKET",
            value: data
        });
    }

    updateFreeBetsEntitlements(data) {
        AppDispatcher.dispatch({
            actionType: "UPDATE_FREEBETS_ENTITLEMENTS",
            value: data
        });
    }

    updateSportsBookPrice(data) {
        AppDispatcher.dispatch({
            actionType: "UPDATE_SPORTSBOOK_PRICE",
            value: data
        });
    }

    placedSportsbookBets(data) {
        AppDispatcher.dispatch({
            actionType: "PLACED_SPORTSBOOK_BETS",
            value: data
        });
    }

    closeBetReceipt(data) {
        AppDispatcher.dispatch({
            actionType: "CLOSE_BETRECEIPT",
            value: data
        });
    }

    clearBetslip(data) {
        AppDispatcher.dispatch({
            actionType: "CLEAR_PRICES",
            value: data
        });
        AppDispatcher.dispatch({
            actionType: "CLEAR_BETSLIP",
            value: data
        });
    }

    checkFreeBets(data) {
        AppDispatcher.dispatch({
            actionType: "CHECK_FREEBETS",
            value: data
        });
    }

    cancelAllBets(data) {
        AppDispatcher.dispatch({
            actionType: "CANCEL_ALL_BETS",
            value: data
        });
    }

    cancelBetConfirm(data) {
        AppDispatcher.dispatch({
            actionType: "CANCEL_BET_CONFIRM",
            value: data
        });
    }

    clickBetslipTab(data) {
        AppDispatcher.dispatch({
            actionType: "CLICK_BETSLIP_TAB",
            value: data
        });
    }

    clickCKT(data) {
        AppDispatcher.dispatch({
            actionType: "CLICK_BETSLIP_CKT",
            value: data
        });
    }

    setBack2WinLay2Lose(data) {
        AppDispatcher.dispatch({
            actionType: "SET_BETSLIP_BACK2WIN_LAY2LOSE",
            value: data
        });
    }

    checkExpiryTime(data) {
        AppDispatcher.dispatch({
            actionType: "CHECK_BETSLIP_EXPIRY_TIME",
            value: data
        });
    }

    clickCloseNotification(data) {
        AppDispatcher.dispatch({
            actionType: "CLOSE_BETSLIP_NOTIFICATION",
            value: data
        });
    }

    setExpiryTime(data) {
        AppDispatcher.dispatch({
            actionType: "SET_BETSLIP_EXPIRY_TIME",
            value: data
        });
    }

    checkAverageOdds(data) {
        AppDispatcher.dispatch({
            actionType: "CHECK_BETSLIP_AVERAGE_ODDS",
            value: data
        });
    }

    setProcessing(data) {
        AppDispatcher.dispatch({
            actionType: "SET_BETSLIP_PROCESSING",
            value: data
        });
    }

    //multiple betslip
    setMultipleBetQuotations(data) {
        AppDispatcher.dispatch({
            actionType: "SET_MULTIPLE_QUOTATIONS",
            value: data
        });
    }

    setSBMultipleBetQuotations(data) {
        AppDispatcher.dispatch({
            actionType: "SET_SB_MULTIPLE_QUOTATIONS",
            value: data
        });
    }

    processCurrentBets(data) {
        AppDispatcher.dispatch({
            actionType: "PROCESS_CURRENT_BETS",
            value: data
        });
    }

    changeMultiStake(data) {
        AppDispatcher.dispatch({
            actionType: "CHANGE_MULTI_STAKE",
            value: data
        });
    }

    stepMultiStake(data) {
        AppDispatcher.dispatch({
            actionType: "STEP_MULTI_STAKE",
            value: data
        });
    }

    changeMultiOutcome(data) {
        AppDispatcher.dispatch({
            actionType: "CHANGE_MULTI_OUTCOME",
            value: data
        });
    }

    stepMultiOutcome(data) {
        AppDispatcher.dispatch({
            actionType: "STEP_MULTI_OUTCOME",
            value: data
        });
    }

    clickMultipleSelection(data) {
        AppDispatcher.dispatch({
            actionType: "CLICK_MULTI_SELECTION",
            value: data
        });
    }

    changedSportbookBetslip(data) {
        AppDispatcher.dispatch({
            actionType: "CHANGED_SB_BETSLIP",
            value: data
        });
    }

    removeSportbookBet(data) {
        AppDispatcher.dispatch({
            actionType: "STORE_REMOVE_SB_BET",
            value: data
        });
    }

    clearSportbookBets(data) {
        AppDispatcher.dispatch({
            actionType: "STORE_CLEAR_SB_BETS",
            value: data
        });
    }

    setActivetBetCursor(data) {
        AppDispatcher.dispatch({
            actionType: "SET_ACTIVE_BET_CURSOR",
            value: data
        });
    }

    multiplesSBCounterOffer(data) {
        AppDispatcher.dispatch({
            actionType: "MULTIPLES_COUNTEROFFER",
            value: data
        });
    }

    setVisibleVirtualMarketIds(data) {
        AppDispatcher.dispatch({
            actionType: "SET_VISIBLE_VIRTUAL_MARKET_IDS",
            value: data
        });
    }
}

export default new BetslipActions();
